export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";